import { render, staticRenderFns } from "./BaseIndulge.vue?vue&type=template&id=20eb9334&scoped=true"
import script from "./BaseIndulge.vue?vue&type=script&lang=js"
export * from "./BaseIndulge.vue?vue&type=script&lang=js"
import style0 from "./BaseIndulge.vue?vue&type=style&index=0&id=20eb9334&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20eb9334",
  null
  
)

export default component.exports